import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from "@angular/core";

@Component({
  selector: "range-slider",
  templateUrl: "./range-slider.component.html",
  styleUrls: ["./range-slider.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class RangeSliderComponent implements OnInit {
  @Input()
  rangeSliderInput;
  @Input()
  screenWidth: string;
  @Output()
  filterRangeInputChange = new EventEmitter();
  range: number[];
  locale: string;
  constructor() {}

  ngOnInit() {
    let locale = window.location.pathname.split("/")[1];
    this.locale = locale;

    this.range = [
      this.rangeSliderInput.selectedMinRangeVal,
      this.rangeSliderInput.selectedMaxRangeVal,
    ];
  }

  onChanges(type, range, $event) {
    let min = ~~range[0];
    let max = ~~range[1];
    let defMin = this.rangeSliderInput.defaultMinRangeVal;
    let defMax = this.rangeSliderInput.defaultMaxRangeVal;

    if (min < defMin || min > max) {
      min = defMin;
    }
    if (max > defMax || max < min) {
      max = defMax;
    }
    if (min === max) {
      if (min > defMin) {
        min--;
      } else {
        max++;
      }
    }
    range[0] = min;
    range[1] = max;
    this.range = [min, max];
    this.filterRangeInputChange.emit({ type, range, $event });
  }
}
